import { render, staticRenderFns } from "./WorkerCompetenceCheck.vue?vue&type=template&id=6015fe1e&scoped=true"
import script from "./WorkerCompetenceCheck.vue?vue&type=script&lang=ts"
export * from "./WorkerCompetenceCheck.vue?vue&type=script&lang=ts"
import style0 from "./WorkerCompetenceCheck.vue?vue&type=style&index=0&id=6015fe1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6015fe1e",
  null
  
)

export default component.exports